import { Card } from '@ipfabric/ui-components/Card/Card';
import { TooltipIcon } from '@ipfabric/ui-components/Tooltip/TooltipIcon';
import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { bgpSettings } from 'app/features/DiscoverySettingsForms/snippets/bgp/bgpSettings';
import { fullBgpIpv4Limit } from 'app/features/DiscoverySettingsForms/snippets/bgp/fullBgpIpv4Limit';
import { fullBgpIpv6Limit } from 'app/features/DiscoverySettingsForms/snippets/bgp/fullBgpIpv6Limit';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const bgpCommunitiesGroup = createFormSnippetGroup({
  snippets: {
    bgpSettings,
    fullBgpIpv4Limit,
    fullBgpIpv6Limit,
  },
  render: ({ renderSnippet }) => (
    // must be in a flex column so the table stretches to full height
    <div className='flex-1 flex flex-col gap'>
      <div className='text-default text-level-4 font-semibold font-heading'>
        BGP communities
      </div>
      <Card className='flex-1 flex flex-col'>
        <SearchableSection
          id='bgp-communities-thresholds'
          className='flex flex-col flex-1 overflow-hidden'
          highlightOn={['routing']}
          wrapperClassName='flex-1 flex flex-col'
        >
          {/* overflow-hidden prevents overlay of round borders */}
          <div className='p flex flex-col gap'>
            <div className='text-default text-level-5 font-semibold font-heading'>
              Threshold settings
              <TooltipIcon
                className='ml-3xs'
                iconProps={{
                  inline: true,
                }}
                content={
                  <>
                    <p>
                      It is recommended to disable BGP route processing if you
                      have FULL BGP routers in the network. BGP routes will be
                      downloaded in particular routing instance, if their count
                      is less than the threshold.
                    </p>
                    <p>
                      This feature is implemented on:
                      <br />
                      Cisco IOS, IOS-XE, IOS-XR, NX-OS
                      <br />
                      Juniper Junos, Arista EOS, Huawei VRP
                    </p>
                  </>
                }
              />
            </div>
            <SearchableSection id='bgp-communities-ipv4-limit'>
              {renderSnippet('fullBgpIpv4Limit')}
            </SearchableSection>
            <SearchableSection id='bgp-communities-ipv6-limit'>
              {renderSnippet('fullBgpIpv6Limit')}
            </SearchableSection>
          </div>
          <div className='border-t border-default' />
          <SearchableSection
            id='bgp-communities-settings'
            searchTerms={['Device list']}
            className='flex flex-col flex-1'
            wrapperClassName='flex flex-col flex-1'
          >
            {renderSnippet('bgpSettings')}
          </SearchableSection>
        </SearchableSection>
      </Card>
    </div>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('routing');
  },
});
